import { DimensionSettings } from '@fullstory/proto/fs/api/metrics';
import {
  DependentEventFilter,
  Retention,
  TimeInterval,
  TimeRange,
} from '@fullstory/proto/fs/api/segment';
import { AuditMetadata } from '@fullstory/proto/fs/gcloud/dstore/protoauditstore';
import { RetentionMetricDetail } from '@fullstory/proto/fs/services/dx-objects';
import {
  RetentionMetricSettings,
  SegmentSettings,
} from '@fullstory/proto/fs/services/search-settings/visualizationsettings';
import { timestamp, Timestamp } from '@fullstory/proto/google/protobuf';
import { defaultSegmentSettings } from '../savedFunnels';
import { DEFAULT_AUDIT_METADATA, mockAuditMetadata } from '../shared/metadata';

export const DEFAULT_RETENTION_TITLE = 'Test Retention';

interface MockRetentionDetailParams {
  id?: string;
  name?: string;
  description?: string;
  retentionMetric?: Partial<Retention>;
  retentionSettings?: Partial<RetentionMetricSettings>;
  metadata?: Partial<AuditMetadata>;
  lastViewed?: timestamp | null;
  starred?: boolean;
  deps?: DependentEventFilter[];
  timeInterval?: TimeInterval;
  segment?: SegmentSettings[];
  timeRange?: TimeRange;
  dimensionSettings?: DimensionSettings | null;
}

export const mockRetentionDetail = ({
  id = 'test',
  name = DEFAULT_RETENTION_TITLE,
  description = 'This is a test retention',
  retentionMetric = {},
  retentionSettings = {},
  metadata = DEFAULT_AUDIT_METADATA,
  lastViewed = Timestamp.now(),
  starred = true,
  deps = [],
  timeInterval = TimeInterval.TIME_INTERVAL_DAY,
  segment = defaultSegmentSettings,
  timeRange = { startTime: 'NOW/DAY-6DAY', endTime: 'NOW/DAY+1DAY' },
  dimensionSettings = null,
}: MockRetentionDetailParams): RetentionMetricDetail => ({
  retentionMetric: {
    retentionMetric: {
      id,
      name,
      description,
      retentionMetric: {
        entry: {
          primary: null,
          deps,
        },
        returns: [
          {
            primary: null,
            deps,
          },
        ],
        constraints: null,
        timeInterval,
        onOrAfter: false,
        multipleEntries: false,
        ...retentionMetric,
      },
      retentionSettings: {
        segment,
        dimensionSettings,
        timeRange,
        timeInterval,
        returnWindow: null,
        timeRangeComparison: null,
        ...retentionSettings,
      },
    },
    metadata: mockAuditMetadata(metadata),
  },
  starred,
  lastViewed,
});
